export const accountSetup = {
  payments: {
    planUnavailableTitle: "Non disponibile nel tuo piano",
    planUnavailableMessage:
      "I pagamenti degli ospiti tramite Stripe sono disponibili solo nei piani Standard e superiori. Aggiorna il tuo piano per abilitare questa funzione e iniziare a incassare i pagamenti direttamente, senza intermediari.",
  },
  modalConnection: {
    header: "Collega un PMS",
    loaderMessage: "Salvataggio in corso, attendi.",
    selectPmsLabel: "Seleziona un sistema PMS",
    selectPmsPlaceholder: "Seleziona un PMS",
    apiKeyLabel: "API Key {pms}",
    apiKeyPlaceholder: "Inserisci la tua API Key",
    cancel: "Annulla",
    save: "Salva connessione",
    fieldRequired: "Campo obbligatorio",
    selectPmsError: "Seleziona un PMS",
    apiKeyError: "Inserisci l'API Key",
    savedTitle: "Connessione salvata",
    savedMessage: "La connessione è stata salvata con successo",
    saveFailMessage: "Impossibile salvare la connessione",
    errorTitle: "Errore",
    serverError: "Errore di connessione al server",
  },
  subscription: {
    title: "Il mio abbonamento",
    subtitle: "Visualizza e gestisci il tuo piano, il metodo di pagamento e la fatturazione.",
    statusActive: "Attivo",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Annullata · attiva fino al",
    validUntil: "Attiva fino al:",
    statusPaymentPending: "Pagamento in sospeso",
    statusTrial: "Periodo di prova",
    statusNone: "Nessun abbonamento attivo",
    intervalYearly: "Piano annuale",
    intervalMonthly: "Piano mensile",
    perMonthShort: "/mese",
    nextRenewal: "Prossimo rinnovo:",
    servicesIncluded: "Servizi inclusi",
    units: "unità | unità",
    perUnitSuffix: "/unità",
    serviceFallback: "Servizio",
    manageOpening: "Apertura…",
    manageButton: "Gestisci abbonamento e fatture",
    emptyText:
      "Non hai ancora un piano attivo. Scegline uno per iniziare a ricevere check-in e pagamenti.",
    buyPlan: "Acquista un piano",
    types: {
      apartment: "Appartamento",
      hotel: "Hotel",
      room: "Camera",
      camping: "Campeggio",
      villa: "Villa",
      chatbot: "Reception AI",
    },
  },
  purchased: {
    title: "Disponibile nel tuo abbonamento",
    subtitle: "Quantità contrattata e utilizzo attuale",
    accommodations: "Alloggi",
    empty: "Non hai ancora creato alcun alloggio.",
    createProperty: "Crea struttura",
    adjust: "Modifica",
    loadError: "Impossibile caricare le informazioni.",
    labels: {
      apartment: "Appartamento/i",
      hotel: "Hotel (camere)",
      hotelPack: "Hotel (camere) · #{id}",
      villa: "Ville",
      camping: "Campeggi",
      campingPack: "Campeggi · #{id}",
      chatbot: "Licenze chatbot",
    },
    units: {
      unid: "unità",
      room: "camere",
      spots: "posti",
      licenses: "licenze",
    },
    types: {
      hotel: "Hotel",
      camping: "Campeggio",
      villa: "Villa",
      apartment: "Appartamento",
    },
    badge: {
      rooms: "{n} camere",
      spots: "{n} posti",
      unit: "1 unità",
    },
  },
  notifications: {
    title: "Notifiche",
    description: "Attiva o disattiva le automazioni di messaggistica e gli avvisi.",
    loading: "Caricamento delle impostazioni...",
    alwaysActive: "Sempre attivo",
    active: "Attivo",
    inactive: "Inattivo",
    hint:
      "Nota: alcune automazioni sono mostrate a titolo informativo perché fanno già parte del flusso standard del sistema.",
    loadError: "Impossibile caricare le impostazioni.",
    saveError: "Impossibile salvare la modifica. Nuovo tentativo in corso...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Conferma di prenotazione (WhatsApp)",
        description:
          "Invia automaticamente il modello di conferma quando una prenotazione viene confermata.",
      },
      email_checkin_sent: {
        title: "Notifiche email quando il check-in viene inviato",
        description:
          "Invia un'email automatica quando il processo di check-in viene completato o inviato.",
      },
      whatsapp_checkin_link_auto: {
        title: "Invia WhatsApp automatico per il check-in online",
        description:
          "Invia automaticamente il link per il check-in online tramite WhatsApp quando applicabile.",
      },
      checkin_link_send_policy: {
        title: "Politica di invio del link per il check-in per le prenotazioni dirette",
        description:
          "Stabilisci se il link viene inviato sempre o solo quando la prenotazione è pagata o parzialmente pagata.",
        options: {
          always: {
            label: "Invia sempre",
            description:
              "Invia il link per il check-in indipendentemente dallo stato del pagamento.",
          },
          paid_or_partially_paid: {
            label: "Solo pagate o parzialmente pagate",
            description:
              "Invia il link solo se la prenotazione è pagata per intero o in parte. Si applica solo alle prenotazioni dirette.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Colombia",
    statusVerified: "Connesso",
    statusPending: "Non verificato",
    publicKeyLabel: "Chiave pubblica",
    privateKeyLabel: "Chiave privata",
    keepPrivateLabel: "Mantieni la chiave privata salvata (nascosta per sicurezza)",
    privatePlaceholderSaved: "•••••••••••• (salvata)",
    btnDisconnect: "Disconnetti",
    btnVerify: "Verifica account",
    btnSave: "Salva credenziali",
    merchantHeader: "Esercente rilevato",
    missingPublicKey: "Chiave pubblica mancante",
    missingPrivateKey: "Chiave privata mancante",
    savedOk: "Credenziali salvate con successo",
    saveError: "Errore durante il salvataggio delle credenziali",
    verifiedOk: "Account verificato",
    notVerified: "Account non verificato",
    verifyError: "Errore durante la verifica dell'account",
    disconnectConfirm: "Sei sicuro di voler disconnettere Wompi da questa attività?",
    disconnectedOk: "Disconnesso con successo",
    disconnectError: "Errore durante la disconnessione",
  },
  pricelabs: {
    subtitle: "Ottimizzazione dinamica dei prezzi",
    statusConnected: "Connesso",
    statusDisconnected: "Non connesso",
    loading: "Caricamento delle impostazioni...",
    emailLabel: "Email PriceLabs",
    emailPlaceholder: "your-email@pricelabs.com",
    importantTitle: "Importante:",
    bullet1: "Assicurati che le tue strutture siano completamente configurate",
    bullet2: "Scegli quali annunci vanno su PriceLabs",
    bullet3:
      "I prezzi verranno aggiornati in base a PriceLabs e non potranno essere modificati manualmente da Wacheckin",
    btnConnect: "Connetti e sincronizza",
    btnConnecting: "Connessione in corso...",
    btnSync: "Sincronizza",
    btnSyncing: "Sincronizzazione in corso...",
    btnDisconnect: "Disconnetti",
    btnDisconnecting: "Disconnessione in corso...",
    emailRequired: "Inserisci la tua email PriceLabs",
    emailRequiredTitle: "Email obbligatoria",
    connectHeader: "Connettersi con PriceLabs?",
    connectMessage:
      "Tutte le tue strutture e camere attive verranno collegate. Tariffe e disponibilità verranno sincronizzate. Qualsiasi struttura/camera creata in seguito verrà inviata automaticamente.",
    connectAccept: "Sì, connetti",
    cancel: "Annulla",
    linkError: "Errore durante il collegamento delle unità",
    emailNotFoundConnect:
      "PriceLabs ha segnalato che l'email non esiste. Controlla la tua email e riprova.",
    emailInvalidTitle: "Email PriceLabs non valida",
    syncSuccess: "Le tue strutture sono ora connesse con PriceLabs.",
    syncSuccessTitle: "Sincronizzazione completata!",
    syncFail: "Impossibile completare la sincronizzazione",
    errorTitle: "Errore",
    emailNotFoundManual:
      "PriceLabs ha indicato che l'email non esiste. Correggi l'email e sincronizza di nuovo.",
    manualSuccess: "Il processo è stato completato con successo.",
    manualSuccessTitle: "Sincronizzazione manuale",
    manualFail: "Impossibile sincronizzare con PriceLabs",
    rejected: "PriceLabs ha rifiutato {count} annuncio/i. {detail}",
    rejectedTitle: "Sincronizzazione non riuscita",
    nothingSent: "Nessun annuncio inviato. Controlla che quelli scelti abbiano prezzo e valuta.",
    relinked: "{count} annuncio/i erano ancora legati a un altro account PriceLabs: sono stati inviati con un nuovo identificativo, quindi lì risultano nuovi.",
    relinkedTitle: "Nuovo identificativo",
    syncedAt: "Sincronizzato · {when}",
    notSyncedYet: "Collegato, non ancora inviato",
    noneSelected: "Non hai scelto nessun alloggio. Seleziona quelli da portare su PriceLabs e sincronizza di nuovo.",
    disconnectHeader: "Disconnettere PriceLabs?",
    disconnectMessage: "Tutte le tue strutture verranno scollegate da PriceLabs.",
    disconnectAccept: "Sì, disconnetti",
    disconnectedOk: "Il tuo account è stato disconnesso da PriceLabs",
    disconnectedTitle: "Disconnesso",
    disconnectFail: "Impossibile disconnettersi da PriceLabs",
    noErrorsReported: "Nessun errore segnalato.",
    listingPrefix: "Annuncio {id}: ",
    unknownError: "Errore sconosciuto",
    listTitle: "Quali annunci vanno su PriceLabs",
    listHint: "Scegli quali deve gestire PriceLabs. Quelli che lasci spenti mantengono i loro prezzi e li modifichi tu.",
    listCount: "{n} di {total} selezionati",
    listSearch: "Cerca una struttura o una camera…",
    listRooms: "{n} camere",
    listApartment: "Appartamento",
    listEmpty: "Non hai ancora strutture.",
    listNoMatch: "Nessuna struttura con quel nome.",
    listNeedsCurrency: "Manca la valuta",
    listNeedsRate: "Manca una tariffa",
    btnConnectN: "Collega e sincronizza | Collega e sincronizza {n} | Collega e sincronizza {n}",
    unitConnected: "{name} ora va su PriceLabs",
    unitDisconnected: "{name} non va più su PriceLabs",
    unitFail: "Non è stato possibile cambiare. Riprova.",
    listLocked: "Collega il tuo account PriceLabs e qui potrai scegliere quali annunci gestisce.",
    listAll: "Tutti",
    listNone: "Nessuno",
    btnSyncN: "Sincronizza | Sincronizza 1 annuncio | Sincronizza {n} annunci",
    connectedOk: "Account collegato. Ora scegli quali annunci vanno su PriceLabs.",
    connectedTitle: "Fatto",
  },
};
